// https://www.warrants.com.sg/MarketDataJSON?type=picker&ric=9988.HK&type2=CALL&qid=1613461363013
// https://www.warrants.com.sg/alert?TYPE=XML&RIC=9988.HK&PERIODICITY=D&d=1613446614192&u=1
const ALIBABA = {
    D: "09:00;0.000|09:01;0.000|09:02;0.000|09:03;0.000|09:04;0.000|09:05;0.000|09:06;0.000|09:07;0.000|09:08;0.000|09:09;0.000|09:10;0.000|09:11;0.000|09:12;0.000|09:13;0.000|09:14;0.000|09:15;0.000|09:16;0.000|09:17;0.000|09:18;0.000|09:19;0.000|09:20;0.000|09:21;0.000|09:22;0.000|09:23;0.000|09:24;0.000|09:25;0.000|09:26;0.000|09:27;0.000|09:28;0.000|09:29;0.000|09:30;0.000|09:31;265.200|09:31;265.200|09:32;265.700|09:32;265.700|09:33;265.200|09:33;265.200|09:34;265.000|09:34;265.000|09:35;265.000|09:35;265.000|09:36;264.400|09:36;264.400|09:37;264.500|09:37;264.500|09:38;263.800|09:38;263.800|09:39;263.800|09:39;263.800|09:40;264.400|09:40;264.400|09:41;264.400|09:41;264.400|09:42;264.400|09:42;264.400|09:43;264.400|09:43;264.400|09:44;264.500|09:44;264.500|09:45;264.400|09:45;264.400|09:46;264.800|09:46;264.800|09:47;264.800|09:47;264.800|09:48;264.400|09:48;264.400|09:49;264.800|09:49;264.800|09:50;264.800|09:50;264.800|09:51;264.800|09:51;264.800|09:52;264.400|09:52;264.400|09:53;264.600|09:53;264.600|09:54;264.600|09:54;264.600|09:55;264.800|09:55;264.800|09:56;264.400|09:56;264.400|09:57;264.200|09:57;264.200|09:58;264.100|09:58;264.100|09:59;263.600|09:59;263.600|10:00;263.400|10:00;263.400|10:01;263.800|10:01;263.800|10:02;263.800|10:02;263.800|10:03;264.000|10:03;264.000|10:04;263.800|10:04;263.800|10:05;263.700|10:05;263.700|10:06;263.200|10:06;263.200|10:07;263.400|10:07;263.400|10:08;263.400|10:08;263.400|10:09;263.300|10:09;263.300|10:10;263.400|10:10;263.400|10:11;263.200|10:11;263.200|10:12;263.300|10:12;263.300|10:13;263.500|10:13;263.500|10:14;263.700|10:14;263.700|10:15;263.600|10:15;263.600|10:16;263.500|10:16;263.500|10:17;263.600|10:17;263.600|10:18;263.400|10:18;263.400|10:19;263.600|10:19;263.600|10:20;263.500|10:20;263.500|10:21;263.700|10:21;263.700|10:22;263.700|10:22;263.700|10:23;263.800|10:23;263.800|10:24;263.600|10:24;263.600|10:25;263.600|10:25;263.600|10:26;264.200|10:26;264.200|10:27;264.400|10:27;264.400|10:28;264.400|10:28;264.400|10:29;264.200|10:29;264.200|10:30;264.300|10:30;264.300|10:31;264.400|10:31;264.400|10:32;264.000|10:32;264.000|10:33;264.200|10:33;264.200|10:34;264.700|10:34;264.700|10:35;264.800|10:35;264.800|10:36;264.600|10:36;264.600|10:37;264.700|10:37;264.700|10:38;264.700|10:38;264.700|10:39;264.600|10:39;264.600|10:40;264.400|10:40;264.400|10:41;264.300|10:41;264.300|10:42;264.200|10:42;264.200|10:43;263.800|10:43;263.800|10:44;264.200|10:44;264.200|10:45;263.800|10:45;263.800|10:46;264.000|10:46;264.000|10:47;264.300|10:47;264.300|10:48;264.200|10:48;264.200|10:49;264.300|10:49;264.300|10:50;264.100|10:50;264.100|10:51;264.200|10:51;264.200|10:52;264.300|10:52;264.300|10:53;264.400|10:53;264.400|10:54;264.300|10:54;264.300|10:55;264.500|10:55;264.500|10:56;264.500|10:56;264.500|10:57;264.500|10:57;264.500|10:58;264.600|10:58;264.600|10:59;264.700|10:59;264.700|11:00;264.800|11:00;264.800|11:01;264.700|11:01;264.700|11:02;264.800|11:02;264.800|11:03;264.800|11:03;264.800|11:04;264.800|11:04;264.800|11:05;264.600|11:05;264.600|11:06;264.800|11:06;264.800|11:07;264.900|11:07;264.900|11:08;264.900|11:08;264.900|11:09;265.000|11:09;265.000|11:10;265.200|11:10;265.200|11:11;265.000|11:11;265.000|11:12;265.200|11:12;265.200|11:13;265.200|11:13;265.200|11:14;265.400|11:14;265.400|11:15;265.200|11:15;265.200|11:16;265.400|11:16;265.400|11:17;265.400|11:17;265.400|11:18;265.400|11:18;265.400|11:19;265.300|11:19;265.300|11:20;265.200|11:20;265.200|11:21;265.400|11:21;265.400|11:22;265.400|11:22;265.400|11:23;265.200|11:23;265.200|11:24;265.300|11:24;265.300|11:25;265.400|11:25;265.400|11:26;265.200|11:26;265.200|11:27;265.200|11:27;265.200|11:28;265.400|11:28;265.400|11:29;265.400|11:29;265.400|11:30;265.200|11:30;265.200|11:31;265.200|11:31;265.200|11:32;265.400|11:32;265.400|11:33;265.400|11:33;265.400|11:34;265.400|11:34;265.400|11:35;265.200|11:35;265.200|11:36;264.600|11:36;264.600|11:37;264.800|11:37;264.800|11:38;265.000|11:38;265.000|11:39;|11:40;|11:41;|11:42;|11:43;|11:44;|11:45;|11:46;|11:47;|11:48;|11:49;|11:50;|11:51;|11:52;|11:53;|11:54;|11:55;|11:56;|11:57;|11:58;|11:59;|12:00;|12:01;|12:02;|12:03;|12:04;|12:05;|12:06;|12:07;|12:08;|12:09;|12:10;|12:11;|12:12;|12:13;|12:14;|12:15;|12:16;|12:17;|12:18;|12:19;|12:20;|12:21;|12:22;|12:23;|12:24;|12:25;|12:26;|12:27;|12:28;|12:29;|12:30;|12:31;|12:32;|12:33;|12:34;|12:35;|12:36;|12:37;|12:38;|12:39;|12:40;|12:41;|12:42;|12:43;|12:44;|12:45;|12:46;|12:47;|12:48;|12:49;|12:50;|12:51;|12:52;|12:53;|12:54;|12:55;|12:56;|12:57;|12:58;|12:59;|13:00;|13:01;|13:02;|13:03;|13:04;|13:05;|13:06;|13:07;|13:08;|13:09;|13:10;|13:11;|13:12;|13:13;|13:14;|13:15;|13:16;|13:17;|13:18;|13:19;|13:20;|13:21;|13:22;|13:23;|13:24;|13:25;|13:26;|13:27;|13:28;|13:29;|13:30;|13:31;|13:32;|13:33;|13:34;|13:35;|13:36;|13:37;|13:38;|13:39;|13:40;|13:41;|13:42;|13:43;|13:44;|13:45;|13:46;|13:47;|13:48;|13:49;|13:50;|13:51;|13:52;|13:53;|13:54;|13:55;|13:56;|13:57;|13:58;|13:59;|14:00;|14:01;|14:02;|14:03;|14:04;|14:05;|14:06;|14:07;|14:08;|14:09;|14:10;|14:11;|14:12;|14:13;|14:14;|14:15;|14:16;|14:17;|14:18;|14:19;|14:20;|14:21;|14:22;|14:23;|14:24;|14:25;|14:26;|14:27;|14:28;|14:29;|14:30;|14:31;|14:32;|14:33;|14:34;|14:35;|14:36;|14:37;|14:38;|14:39;|14:40;|14:41;|14:42;|14:43;|14:44;|14:45;|14:46;|14:47;|14:48;|14:49;|14:50;|14:51;|14:52;|14:53;|14:54;|14:55;|14:56;|14:57;|14:58;|14:59;|15:00;|15:01;|15:02;|15:03;|15:04;|15:05;|15:06;|15:07;|15:08;|15:09;|15:10;|15:11;|15:12;|15:13;|15:14;|15:15;|15:16;|15:17;|15:18;|15:19;|15:20;|15:21;|15:22;|15:23;|15:24;|15:25;|15:26;|15:27;|15:28;|15:29;|15:30;|15:31;|15:32;|15:33;|15:34;|15:35;|15:36;|15:37;|15:38;|15:39;|15:40;|15:41;|15:42;|15:43;|15:44;|15:45;|15:46;|15:47;|15:48;|15:49;|15:50;|15:51;|15:52;|15:53;|15:54;|15:55;|15:56;|15:57;|15:58;|15:59;|16:00;|16:01;|16:02;|16:03;|16:04;|16:05;|16:06;|16:07;|16:08;|16:09;|16:10;|16:11;|16:12;|16:13;|16:14;|16:15;|16:16;|16:17;|16:18;|16:19;|16:20;|16:21;|16:22;|16:23;|16:24;|16:25;|16:26;|16:27;|16:28;|16:29;|16:30;|16:31;|16:32;|16:33;|16:34;|16:35;|16:36;|16:37;|16:38;|16:39;|16:40;|16:41;|16:42;|16:43;|16:44;|16:45;|16:46;|16:47;|16:48;|16:49;|16:50;|16:51;|16:52;|16:53;|16:54;|16:55;|16:56;|16:57;|16:58;|16:59;|17:00;",
    W: "2021-02-09;2021-02-10;2021-02-11=2021-02-09;255.400|2021-02-10;262.000|2021-02-11;261.000|2021-02-16;264.600",
    M: "2021-01-18;2021-01-19;2021-01-20;2021-01-21;2021-01-22;2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11=2021-01-18;242.000|2021-01-19;244.200|2021-01-20;265.000|2021-01-21;258.600|2021-01-22;250.600|2021-01-25;258.000|2021-01-26;253.400|2021-01-27;260.000|2021-01-28;251.600|2021-01-29;246.800|2021-02-01;251.200|2021-02-02;260.000|2021-02-03;261.000|2021-02-04;262.200|2021-02-05;258.000|2021-02-08;256.400|2021-02-09;255.400|2021-02-10;262.000|2021-02-11;261.000|2021-02-16;265.100",
    Y: "2020-02-17;2020-02-18;2020-02-19;2020-02-20;2020-02-21;2020-02-24;2020-02-25;2020-02-26;2020-02-27;2020-02-28;2020-03-02;2020-03-03;2020-03-04;2020-03-05;2020-03-06;2020-03-09;2020-03-10;2020-03-11;2020-03-12;2020-03-13;2020-03-16;2020-03-17;2020-03-18;2020-03-19;2020-03-20;2020-03-23;2020-03-24;2020-03-25;2020-03-26;2020-03-27;2020-03-30;2020-03-31;2020-04-01;2020-04-02;2020-04-03;2020-04-06;2020-04-07;2020-04-08;2020-04-09;2020-04-14;2020-04-15;2020-04-16;2020-04-17;2020-04-20;2020-04-21;2020-04-22;2020-04-23;2020-04-24;2020-04-27;2020-04-28;2020-04-29;2020-05-04;2020-05-05;2020-05-06;2020-05-07;2020-05-08;2020-05-11;2020-05-12;2020-05-13;2020-05-14;2020-05-15;2020-05-18;2020-05-19;2020-05-20;2020-05-21;2020-05-22;2020-05-25;2020-05-26;2020-05-27;2020-05-28;2020-05-29;2020-06-01;2020-06-02;2020-06-03;2020-06-04;2020-06-05;2020-06-08;2020-06-09;2020-06-10;2020-06-11;2020-06-12;2020-06-15;2020-06-16;2020-06-17;2020-06-18;2020-06-19;2020-06-22;2020-06-23;2020-06-24;2020-06-26;2020-06-29;2020-06-30;2020-07-02;2020-07-03;2020-07-06;2020-07-07;2020-07-08;2020-07-09;2020-07-10;2020-07-13;2020-07-14;2020-07-15;2020-07-16;2020-07-17;2020-07-20;2020-07-21;2020-07-22;2020-07-23;2020-07-24;2020-07-27;2020-07-28;2020-07-29;2020-07-30;2020-07-31;2020-08-03;2020-08-04;2020-08-05;2020-08-06;2020-08-07;2020-08-10;2020-08-11;2020-08-12;2020-08-13;2020-08-14;2020-08-17;2020-08-18;2020-08-19;2020-08-20;2020-08-21;2020-08-24;2020-08-25;2020-08-26;2020-08-27;2020-08-28;2020-08-31;2020-09-01;2020-09-02;2020-09-03;2020-09-04;2020-09-07;2020-09-08;2020-09-09;2020-09-10;2020-09-11;2020-09-14;2020-09-15;2020-09-16;2020-09-17;2020-09-18;2020-09-21;2020-09-22;2020-09-23;2020-09-24;2020-09-25;2020-09-28;2020-09-29;2020-09-30;2020-10-05;2020-10-06;2020-10-07;2020-10-08;2020-10-09;2020-10-12;2020-10-14;2020-10-15;2020-10-16;2020-10-19;2020-10-20;2020-10-21;2020-10-22;2020-10-23;2020-10-27;2020-10-28;2020-10-29;2020-10-30;2020-11-02;2020-11-03;2020-11-04;2020-11-05;2020-11-06;2020-11-09;2020-11-10;2020-11-11;2020-11-12;2020-11-13;2020-11-16;2020-11-17;2020-11-18;2020-11-19;2020-11-20;2020-11-23;2020-11-24;2020-11-25;2020-11-26;2020-11-27;2020-11-30;2020-12-01;2020-12-02;2020-12-03;2020-12-04;2020-12-07;2020-12-08;2020-12-09;2020-12-10;2020-12-11;2020-12-14;2020-12-15;2020-12-16;2020-12-17;2020-12-18;2020-12-21;2020-12-22;2020-12-23;2020-12-24;2020-12-28;2020-12-29;2020-12-30;2020-12-31;2021-01-04;2021-01-05;2021-01-06;2021-01-07;2021-01-08;2021-01-11;2021-01-12;2021-01-13;2021-01-14;2021-01-15;2021-01-18;2021-01-19;2021-01-20;2021-01-21;2021-01-22;2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11=2020-02-17;217.400|2020-02-18;214.000|2020-02-19;214.000|2020-02-20;215.600|2020-02-21;212.600|2020-02-24;205.200|2020-02-25;206.600|2020-02-26;203.000|2020-02-27;205.200|2020-02-28;200.000|2020-03-02;204.600|2020-03-03;203.200|2020-03-04;202.200|2020-03-05;207.200|2020-03-06;203.800|2020-03-09;193.500|2020-03-10;199.300|2020-03-11;197.000|2020-03-12;188.800|2020-03-13;191.700|2020-03-16;179.300|2020-03-17;183.200|2020-03-18;173.000|2020-03-19;174.000|2020-03-20;183.000|2020-03-23;170.000|2020-03-24;174.500|2020-03-25;179.700|2020-03-26;180.900|2020-03-27;183.900|2020-03-30;180.300|2020-03-31;183.400|2020-04-01;184.000|2020-04-02;186.000|2020-04-03;183.700|2020-04-06;188.600|2020-04-07;191.500|2020-04-08;190.100|2020-04-09;191.700|2020-04-14;197.000|2020-04-15;197.900|2020-04-16;202.800|2020-04-17;207.600|2020-04-20;205.800|2020-04-21;204.200|2020-04-22;205.600|2020-04-23;204.400|2020-04-24;198.000|2020-04-27;200.600|2020-04-28;199.000|2020-04-29;197.000|2020-05-04;189.700|2020-05-05;188.500|2020-05-06;193.600|2020-05-07;190.500|2020-05-08;193.400|2020-05-11;198.700|2020-05-12;199.700|2020-05-13;196.300|2020-05-14;194.500|2020-05-15;196.900|2020-05-18;203.000|2020-05-19;209.800|2020-05-20;211.000|2020-05-21;206.200|2020-05-22;198.200|2020-05-25;198.200|2020-05-26;201.000|2020-05-27;197.300|2020-05-28;193.500|2020-05-29;194.300|2020-06-01;202.800|2020-06-02;200.000|2020-06-03;209.600|2020-06-04;211.000|2020-06-05;212.200|2020-06-08;212.400|2020-06-09;212.400|2020-06-10;215.600|2020-06-11;213.000|2020-06-12;212.000|2020-06-15;206.800|2020-06-16;213.200|2020-06-17;217.800|2020-06-18;217.800|2020-06-19;219.000|2020-06-22;213.000|2020-06-23;220.000|2020-06-24;221.400|2020-06-26;214.600|2020-06-29;209.400|2020-06-30;209.600|2020-07-02;214.400|2020-07-03;220.800|2020-07-06;225.400|2020-07-07;232.400|2020-07-08;237.800|2020-07-09;261.600|2020-07-10;255.400|2020-07-13;254.400|2020-07-14;240.400|2020-07-15;243.400|2020-07-16;233.200|2020-07-17;238.800|2020-07-20;239.600|2020-07-21;257.000|2020-07-22;248.000|2020-07-23;246.600|2020-07-24;239.000|2020-07-27;239.000|2020-07-28;244.600|2020-07-29;243.000|2020-07-30;244.800|2020-07-31;246.000|2020-08-03;245.600|2020-08-04;253.800|2020-08-05;255.800|2020-08-06;257.000|2020-08-07;249.200|2020-08-10;242.400|2020-08-11;244.000|2020-08-12;243.400|2020-08-13;248.200|2020-08-14;246.800|2020-08-17;242.800|2020-08-18;252.000|2020-08-19;255.400|2020-08-20;255.000|2020-08-21;252.800|2020-08-24;264.400|2020-08-25;269.200|2020-08-26;280.400|2020-08-27;280.600|2020-08-28;277.000|2020-08-31;282.800|2020-09-01;282.800|2020-09-02;291.200|2020-09-03;284.200|2020-09-04;274.000|2020-09-07;265.600|2020-09-08;269.600|2020-09-09;263.200|2020-09-10;262.600|2020-09-11;266.000|2020-09-14;268.200|2020-09-15;267.400|2020-09-16;273.000|2020-09-17;267.800|2020-09-18;269.600|2020-09-21;262.000|2020-09-22;264.800|2020-09-23;267.000|2020-09-24;261.000|2020-09-25;258.000|2020-09-28;263.400|2020-09-29;265.400|2020-09-30;275.600|2020-10-05;282.000|2020-10-06;280.000|2020-10-07;288.200|2020-10-08;289.600|2020-10-09;286.200|2020-10-12;292.000|2020-10-14;297.600|2020-10-15;284.800|2020-10-16;294.000|2020-10-19;297.200|2020-10-20;299.400|2020-10-21;300.200|2020-10-22;300.000|2020-10-23;298.000|2020-10-27;300.000|2020-10-28;307.400|2020-10-29;302.600|2020-10-30;293.200|2020-11-02;297.800|2020-11-03;299.800|2020-11-04;277.200|2020-11-05;294.600|2020-11-06;282.000|2020-11-09;290.200|2020-11-10;275.400|2020-11-11;248.400|2020-11-12;253.000|2020-11-13;257.000|2020-11-16;254.000|2020-11-17;249.800|2020-11-18;250.000|2020-11-19;245.200|2020-11-20;253.000|2020-11-23;264.000|2020-11-24;270.000|2020-11-25;267.000|2020-11-26;269.000|2020-11-27;269.600|2020-11-30;261.400|2020-12-01;257.200|2020-12-02;255.200|2020-12-03;257.400|2020-12-04;264.000|2020-12-07;258.000|2020-12-08;258.000|2020-12-09;260.800|2020-12-10;255.400|2020-12-11;258.400|2020-12-14;251.600|2020-12-15;246.000|2020-12-16;251.000|2020-12-17;258.000|2020-12-18;255.600|2020-12-21;250.000|2020-12-22;248.800|2020-12-23;248.400|2020-12-24;228.200|2020-12-28;210.000|2020-12-29;222.000|2020-12-30;236.200|2020-12-31;232.600|2021-01-04;227.600|2021-01-05;223.000|2021-01-06;230.000|2021-01-07;221.000|2021-01-08;224.200|2021-01-11;221.000|2021-01-12;220.000|2021-01-13;223.800|2021-01-14;235.000|2021-01-15;241.000|2021-01-18;242.000|2021-01-19;244.200|2021-01-20;265.000|2021-01-21;258.600|2021-01-22;250.600|2021-01-25;258.000|2021-01-26;253.400|2021-01-27;260.000|2021-01-28;251.600|2021-01-29;246.800|2021-02-01;251.200|2021-02-02;260.000|2021-02-03;261.000|2021-02-04;262.200|2021-02-05;258.000|2021-02-08;256.400|2021-02-09;255.400|2021-02-10;262.000|2021-02-11;261.000|2021-02-16;265.100",
    CALL: {
      "data": [
        {
          "underlying_ric": "9988.HK",
          "b_trbc_business": null,
          "theta": "-0.11",
          "LOLIMIT": "0",
          "TRDPRC_1": "0.068",
          "percent_moneyness": "13",
          "last_trading_date": "28 Jun 21",
          "HIGH_1": "0.090",
          "type": "CALL",
          "effective_gearing": "5.8",
          "conv_ratio": "45.0",
          "wrnt_per_share": "0.022",
          "BID_PCTCHNG_2DP": "-12.16",
          "LOW_1": "0.021",
          "30D_LOW": "-",
          "ticker": "R42W",
          "breakeven_price": "317.08",
          "underlying_pctchng": "-2.32",
          "delta_per_wrnt": "0.839",
          "warrant_price": 0.065,
          "TURNOVER_SCALED": "2",
          "OPEN_PRC": "0.072",
          "NO_BIDMKR2": "-",
          "dsply_nmll": "Alibaba MB eCW210705",
          "issuer_name": "Macquarie Bank Ltd",
          "sensitivity": "11.93",
          "delta": "37.7",
          "TRADE_DATE": "18 Feb 21",
          "NO_BIDMKR2_SCALED": "-",
          "underlying_price_adj": 44.67504,
          "BID_PCTCHNG": "-12.2",
          "BIDSIZE": "3,000,200",
          "category": "BABA-SW",
          "underlying_price_cal": 260.8,
          "exercise_price_adj": 51.39,
          "update_time": "18 Feb 21 14:41",
          "dsply_name": "Alibaba MB eCW210705",
          "YRHIGH": "-",
          "BEST_BSIZ1": "3000200",
          "HST_CLOSE": "0.074",
          "ACVOL_1_SCALED": "22",
          "BID": "0.065",
          "r_hst_close": 0.1713,
          "maturity": "05 Jul 21",
          "div_yield": 0.0,
          "underlying_bid": 260.6,
          "fmt": 1,
          "30D_HIGH": "-",
          "SYMBOL": "ALML_th.SI",
          "HST_VOL_SCALED": "-",
          "underlying_price": "260.80",
          "list_date": "17 Dec 20",
          "underlying_curr": "HKD",
          "exchange_code": "SES",
          "ASK": "0.067",
          "currency": "SGD",
          "conv_ratio_cal": 45.00000045,
          "UPLIMIT": "0",
          "BID_NETCHNG": "-0.009",
          "NETCHNG_1": "-0.0",
          "HST_VOL": "-",
          "implied_volatility": "47.6",
          "VOL_PCTCHNG": "-",
          "TRDTIM_1": "05:15",
          "moneyness": "2",
          "ASKSIZE": "3,000,000",
          "premium": "21.6",
          "SERVICE": "ELEKTRON_DD",
          "underlying_ticker": "BABA-SW",
          "intrinsic_value": "0.000",
          "exercise_price_cal": 300.0,
          "issuer_code": "MBL",
          "REC_STATUS": "0",
          "underlying_name": "BABA-SW",
          "TURNOVER": "1,516",
          "PCTCHNG": "-10.5",
          "YRLOW": "-",
          "BEST_ASIZ1": "3000000",
          "ACVOL_1": "22,300",
          "days_to_maturity": "137",
          "ric": "ALML_th.SI",
          "exercise_price": "300.00"
        }
      ]
    },
    PUT: {
      "data": [
          {
              "underlying_ric": "9988.HK",
              "b_trbc_business": null,
              "theta": "-0.08",
              "TRDPRC_1": "0.088",
              "percent_moneyness": "7",
              "last_trading_date": "28 Jun 21",
              "HIGH_1": "0.181",
              "type": "PUT",
              "effective_gearing": "4.0",
              "conv_ratio": "45.0",
              "wrnt_per_share": "0.022",
              "BID_PCTCHNG_2DP": "+4.94",
              "LOW_1": "0.071",
              "30D_LOW": "-",
              "ticker": "QBDW",
              "breakeven_price": "217.63",
              "underlying_pctchng": "-1.31",
              "delta_per_wrnt": "-0.771",
              "warrant_price": 0.085000000,
              "TURNOVER_SCALED": "0",
              "OPEN_PRC": "0.101",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "Alibaba MB ePW210705",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "12.97",
              "delta": "-34.7",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 43.947000000,
              "BID_PCTCHNG": "+4.9",
              "BIDSIZE": "2,600,000",
              "category": "BABA-SW",
              "underlying_price_cal": 257.000000000,
              "exercise_price_adj": 41.040000000,
              "update_time": "19 Feb 21 15:57",
              "dsply_name": "Alibaba MB ePW210705",
              "YRHIGH": "-",
              "HST_CLOSE": "0.081",
              "ACVOL_1_SCALED": "0",
              "BID": "0.085",
              "r_hst_close": 0.1710000000,
              "maturity": "05 Jul 21",
              "div_yield": 0E-9,
              "underlying_bid": 257.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "257.00",
              "list_date": "17 Dec 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.086",
              "currency": "SGD",
              "conv_ratio_cal": 45.000000450,
              "BID_NETCHNG": "+0.004",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "51.0",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "3,000,000",
              "premium": "15.3",
              "underlying_ticker": "BABA-SW",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 240.000000000,
              "issuer_code": "MBL",
              "underlying_name": "BABA-SW",
              "TURNOVER": "18",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "200",
              "days_to_maturity": "136",
              "ric": "ALML_tg.SI",
              "exercise_price": "240.00"
          },
          {
              "underlying_ric": "9988.HK",
              "b_trbc_business": null,
              "theta": "-0.23",
              "TRDPRC_1": "0.142",
              "percent_moneyness": "3",
              "last_trading_date": "26 Mar 21",
              "HIGH_1": "0.330",
              "type": "PUT",
              "effective_gearing": "7.8",
              "conv_ratio": "25.0",
              "wrnt_per_share": "0.040",
              "BID_PCTCHNG_2DP": "+7.14",
              "LOW_1": "0.066",
              "30D_LOW": "-",
              "ticker": "X7RW",
              "breakeven_price": "236.84",
              "underlying_pctchng": "-1.31",
              "delta_per_wrnt": "-1.588",
              "warrant_price": 0.090000000,
              "TURNOVER_SCALED": "0",
              "OPEN_PRC": "0.105",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "AlibabaMBePW210405",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "6.30",
              "delta": "-39.7",
              "TRADE_DATE": "22 Jan 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 43.947000000,
              "BID_PCTCHNG": "+7.1",
              "BIDSIZE": "1,000,000",
              "underlying_price_cal": 257.000000000,
              "exercise_price_adj": 42.750000000,
              "update_time": "19 Feb 21 15:57",
              "dsply_name": "AlibabaMBePW210405",
              "YRHIGH": "-",
              "HST_CLOSE": "0.084",
              "ACVOL_1_SCALED": "0",
              "BID": "0.090",
              "r_hst_close": 0.1710000000,
              "maturity": "05 Apr 21",
              "div_yield": 0E-9,
              "underlying_bid": 257.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "257.00",
              "list_date": "22 Oct 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.092",
              "currency": "SGD",
              "conv_ratio_cal": 25.000000000,
              "BID_NETCHNG": "+0.006",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "46.9",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "1,000,000",
              "premium": "7.8",
              "underlying_ticker": "BABA-SW",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 250.000000000,
              "issuer_code": "MBL",
              "underlying_name": "BABA-SW",
              "TURNOVER": "0",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "0",
              "days_to_maturity": "45",
              "ric": "ALML_te.SI",
              "exercise_price": "250.00"
          }
      ]
  }       
}

const HSI = {
    D: "09:00;0.000|09:01;0.000|09:02;0.000|09:03;0.000|09:04;0.000|09:05;0.000|09:06;0.000|09:07;0.000|09:08;0.000|09:09;0.000|09:10;0.000|09:11;0.000|09:12;0.000|09:13;0.000|09:14;30501.000|09:14;30501.000|09:15;30501.000|09:15;30501.000|09:16;30471.000|09:16;30471.000|09:17;30451.000|09:17;30451.000|09:18;30485.000|09:18;30485.000|09:19;30467.000|09:19;30467.000|09:20;30496.000|09:20;30496.000|09:21;30483.000|09:21;30483.000|09:22;30485.000|09:22;30485.000|09:23;30483.000|09:23;30483.000|09:24;30479.000|09:24;30479.000|09:25;30479.000|09:25;30479.000|09:26;30491.000|09:26;30491.000|09:27;30469.000|09:27;30469.000|09:28;30460.000|09:28;30460.000|09:29;30463.000|09:29;30463.000|09:30;30457.000|09:30;30457.000|09:31;30453.000|09:31;30453.000|09:32;30442.000|09:32;30442.000|09:33;30476.000|09:33;30476.000|09:34;30488.000|09:34;30488.000|09:35;30519.000|09:35;30519.000|09:36;30534.000|09:36;30534.000|09:37;30528.000|09:37;30528.000|09:38;30522.000|09:38;30522.000|09:39;30512.000|09:39;30512.000|09:40;30524.000|09:40;30524.000|09:41;30540.000|09:41;30540.000|09:42;30552.000|09:42;30552.000|09:43;30547.000|09:43;30547.000|09:44;30536.000|09:44;30536.000|09:45;30551.000|09:45;30551.000|09:46;30512.000|09:46;30512.000|09:47;30497.000|09:47;30497.000|09:48;30503.000|09:48;30503.000|09:49;30538.000|09:49;30538.000|09:50;30576.000|09:50;30576.000|09:51;30562.000|09:51;30562.000|09:52;30580.000|09:52;30580.000|09:53;30600.000|09:53;30600.000|09:54;30611.000|09:54;30611.000|09:55;30601.000|09:55;30601.000|09:56;30590.000|09:56;30590.000|09:57;30603.000|09:57;30603.000|09:58;30607.000|09:58;30607.000|09:59;30605.000|09:59;30605.000|10:00;30605.000|10:00;30605.000|10:01;30596.000|10:01;30596.000|10:02;30588.000|10:02;30588.000|10:03;30574.000|10:03;30574.000|10:04;30564.000|10:04;30564.000|10:05;30558.000|10:05;30558.000|10:06;30582.000|10:06;30582.000|10:07;30622.000|10:07;30622.000|10:08;30623.000|10:08;30623.000|10:09;30614.000|10:09;30614.000|10:10;30620.000|10:10;30620.000|10:11;30624.000|10:11;30624.000|10:12;30619.000|10:12;30619.000|10:13;30618.000|10:13;30618.000|10:14;30619.000|10:14;30619.000|10:15;30620.000|10:15;30620.000|10:16;30628.000|10:16;30628.000|10:17;30646.000|10:17;30646.000|10:18;30649.000|10:18;30649.000|10:19;30657.000|10:19;30657.000|10:20;30663.000|10:20;30663.000|10:21;30648.000|10:21;30648.000|10:22;30652.000|10:22;30652.000|10:23;30649.000|10:23;30649.000|10:24;30645.000|10:24;30645.000|10:25;30655.000|10:25;30655.000|10:26;30648.000|10:26;30648.000|10:27;30637.000|10:27;30637.000|10:28;30657.000|10:28;30657.000|10:29;30660.000|10:29;30660.000|10:30;30643.000|10:30;30643.000|10:31;30652.000|10:31;30652.000|10:32;30639.000|10:32;30639.000|10:33;30654.000|10:33;30654.000|10:34;30658.000|10:34;30658.000|10:35;30681.000|10:35;30681.000|10:36;30673.000|10:36;30673.000|10:37;30665.000|10:37;30665.000|10:38;30672.000|10:38;30672.000|10:39;30672.000|10:39;30672.000|10:40;30681.000|10:40;30681.000|10:41;30682.000|10:41;30682.000|10:42;30677.000|10:42;30677.000|10:43;30674.000|10:43;30674.000|10:44;30682.000|10:44;30682.000|10:45;30693.000|10:45;30693.000|10:46;30700.000|10:46;30700.000|10:47;30707.000|10:47;30707.000|10:48;30708.000|10:48;30708.000|10:49;30725.000|10:49;30725.000|10:50;30731.000|10:50;30731.000|10:51;30732.000|10:51;30732.000|10:52;30739.000|10:52;30739.000|10:53;30747.000|10:53;30747.000|10:54;30735.000|10:54;30735.000|10:55;30728.000|10:55;30728.000|10:56;30733.000|10:56;30733.000|10:57;30724.000|10:57;30724.000|10:58;30737.000|10:58;30737.000|10:59;30744.000|10:59;30744.000|11:00;30752.000|11:00;30752.000|11:01;30744.000|11:01;30744.000|11:02;30743.000|11:02;30743.000|11:03;30750.000|11:03;30750.000|11:04;30778.000|11:04;30778.000|11:05;30769.000|11:05;30769.000|11:06;30763.000|11:06;30763.000|11:07;30767.000|11:07;30767.000|11:08;30764.000|11:08;30764.000|11:09;30761.000|11:09;30761.000|11:10;30769.000|11:10;30769.000|11:11;30755.000|11:11;30755.000|11:12;30763.000|11:12;30763.000|11:13;30774.000|11:13;30774.000|11:14;30782.000|11:14;30782.000|11:15;30763.000|11:15;30763.000|11:16;30760.000|11:16;30760.000|11:17;30753.000|11:17;30753.000|11:18;30750.000|11:18;30750.000|11:19;30738.000|11:19;30738.000|11:20;30743.000|11:20;30743.000|11:21;30743.000|11:21;30743.000|11:22;30744.000|11:22;30744.000|11:23;30736.000|11:23;30736.000|11:24;30732.000|11:24;30732.000|11:25;30739.000|11:25;30739.000|11:26;30737.000|11:26;30737.000|11:27;30730.000|11:27;30730.000|11:28;30727.000|11:28;30727.000|11:29;30724.000|11:29;30724.000|11:30;30715.000|11:30;30715.000|11:31;30708.000|11:31;30708.000|11:32;30699.000|11:32;30699.000|11:33;30713.000|11:33;30713.000|11:34;30716.000|11:34;30716.000|11:35;30703.000|11:35;30703.000|11:36;30701.000|11:36;30701.000|11:37;30709.000|11:37;30709.000|11:38;30698.000|11:38;30698.000|11:39;30703.000|11:39;30703.000|11:40;30702.000|11:40;30702.000|11:41;30715.000|11:41;30715.000|11:42;30723.000|11:42;30723.000|11:43;30750.000|11:43;30750.000|11:44;30746.000|11:44;30746.000|11:45;30762.000|11:45;30762.000|11:46;30789.000|11:46;30789.000|11:47;30789.000|11:47;30789.000|11:48;30825.000|11:48;30825.000|11:49;30829.000|11:49;30829.000|11:50;30829.000|11:50;30829.000|11:51;30847.000|11:51;30847.000|11:52;30841.000|11:52;30841.000|11:53;30852.000|11:53;30852.000|11:54;30865.000|11:54;30865.000|11:55;30873.000|11:55;30873.000|11:56;30862.000|11:56;30862.000|11:57;30861.000|11:57;30861.000|11:58;30861.000|11:58;30861.000|11:59;30863.000|11:59;30863.000|11:59;30863.000|12:59;30863.000|12:59;30863.000|13:00;30860.000|13:00;30860.000|13:01;30861.000|13:01;30861.000|13:02;30904.000|13:02;30904.000|13:03;30933.000|13:03;30933.000|13:04;30938.000|13:04;30938.000|13:05;30941.000|13:05;30941.000|13:06;30943.000|13:06;30943.000|13:07;30930.000|13:07;30930.000|13:08;30911.000|13:08;30911.000|13:09;30890.000|13:09;30890.000|13:10;30887.000|13:10;30887.000|13:11;30890.000|13:11;30890.000|13:12;30892.000|13:12;30892.000|13:13;30891.000|13:13;30891.000|13:14;30888.000|13:14;30888.000|13:15;30856.000|13:15;30856.000|13:16;30877.000|13:16;30877.000|13:17;30857.000|13:17;30857.000|13:18;30872.000|13:18;30872.000|13:19;30877.000|13:19;30877.000|13:20;30866.000|13:20;30866.000|13:21;30893.000|13:21;30893.000|13:22;30889.000|13:22;30889.000|13:23;30906.000|13:23;30906.000|13:24;30900.000|13:24;30900.000|13:25;30901.000|13:25;30901.000|13:26;30890.000|13:26;30890.000|13:27;30902.000|13:27;30902.000|13:28;30907.000|13:28;30907.000|13:29;30908.000|13:29;30908.000|13:30;30909.000|13:30;30909.000|13:31;30925.000|13:31;30925.000|13:32;30960.000|13:32;30960.000|13:33;30970.000|13:33;30970.000|13:34;30988.000|13:34;30988.000|13:35;30983.000|13:35;30983.000|13:36;30986.000|13:36;30986.000|13:37;30985.000|13:37;30985.000|13:38;30984.000|13:38;30984.000|13:39;30974.000|13:39;30974.000|13:40;30942.000|13:40;30942.000|13:41;30936.000|13:41;30936.000|13:42;30932.000|13:42;30932.000|13:43;30925.000|13:43;30925.000|13:44;30926.000|13:44;30926.000|13:45;30924.000|13:45;30924.000|13:46;30922.000|13:46;30922.000|13:47;30915.000|13:47;30915.000|13:48;30922.000|13:48;30922.000|13:49;30931.000|13:49;30931.000|13:50;30950.000|13:50;30950.000|13:51;30954.000|13:51;30954.000|13:52;30954.000|13:52;30954.000|13:53;30946.000|13:53;30946.000|13:54;30941.000|13:54;30941.000|13:55;30951.000|13:55;30951.000|13:56;30962.000|13:56;30962.000|13:57;30947.000|13:57;30947.000|13:58;30943.000|13:58;30943.000|13:59;30941.000|13:59;30941.000|14:00;30932.000|14:00;30932.000|14:01;30946.000|14:01;30946.000|14:02;30944.000|14:02;30944.000|14:03;30940.000|14:03;30940.000|14:04;30975.000|14:04;30975.000|14:05;30996.000|14:05;30996.000|14:06;30984.000|14:06;30984.000|14:07;30969.000|14:07;30969.000|14:08;30953.000|14:08;30953.000|14:09;30950.000|14:09;30950.000|14:10;30945.000|14:10;30945.000|14:11;30971.000|14:11;30971.000|14:12;30984.000|14:12;30984.000|14:13;30979.000|14:13;30979.000|14:14;30974.000|14:14;30974.000|14:15;30984.000|14:15;30984.000|14:16;30983.000|14:16;30983.000|14:17;30994.000|14:17;30994.000|14:18;30985.000|14:18;30985.000|14:19;30973.000|14:19;30973.000|14:20;30982.000|14:20;30982.000|14:21;30991.000|14:21;30991.000|14:22;31002.000|14:22;31002.000|14:23;30998.000|14:23;30998.000|14:24;30986.000|14:24;30986.000|14:25;31003.000|14:25;31003.000|14:26;30995.000|14:26;30995.000|14:27;31008.000|14:27;31008.000|14:28;31006.000|14:28;31006.000|14:29;31005.000|14:29;31005.000|14:30;31011.000|14:30;31011.000|14:31;31032.000|14:31;31032.000|14:32;31030.000|14:32;31030.000|14:33;31038.000|14:33;31038.000|14:34;31022.000|14:34;31022.000|14:35;31030.000|14:35;31030.000|14:36;31035.000|14:36;31035.000|14:37;31035.000|14:37;31035.000|14:38;31040.000|14:38;31040.000|14:39;31043.000|14:39;31043.000|14:40;31040.000|14:40;31040.000|14:41;31033.000|14:41;31033.000|14:42;31045.000|14:42;31045.000|14:43;31041.000|14:43;31041.000|14:44;31042.000|14:44;31042.000|14:45;31049.000|14:45;31049.000|14:46;31062.000|14:46;31062.000|14:47;|14:48;|14:49;|14:50;|14:51;|14:52;|14:53;|14:54;|14:55;|14:56;|14:57;|14:58;|14:59;|15:00;|15:01;|15:02;|15:03;|15:04;|15:05;|15:06;|15:07;|15:08;|15:09;|15:10;|15:11;|15:12;|15:13;|15:14;|15:15;|15:16;|15:17;|15:18;|15:19;|15:20;|15:21;|15:22;|15:23;|15:24;|15:25;|15:26;|15:27;|15:28;|15:29;|15:30;|15:31;|15:32;|15:33;|15:34;|15:35;|15:36;|15:37;|15:38;|15:39;|15:40;|15:41;|15:42;|15:43;|15:44;|15:45;|15:46;|15:47;|15:48;|15:49;|15:50;|15:51;|15:52;|15:53;|15:54;|15:55;|15:56;|15:57;|15:58;|15:59;|16:00;|16:01;|16:02;|16:03;|16:04;|16:05;|16:06;|16:07;|16:08;|16:09;|16:10;|16:11;|16:12;|16:13;|16:14;|16:15;|16:16;|16:17;|16:18;|16:19;|16:20;|16:21;|16:22;|16:23;|16:24;|16:25;|16:26;|16:27;|16:28;|16:29;|16:30;|16:31;|16:32;|16:33;|16:34;|16:35;|16:36;|16:37;|16:38;|16:39;|16:40;|16:41;|16:42;|16:43;|16:44;|16:45;|16:46;|16:47;|16:48;|16:49;|16:50;|16:51;|16:52;|16:53;|16:54;|16:55;|16:56;|16:57;|16:58;|16:59;|17:00;",
    W: "2021-02-10;2021-02-11;2021-02-16=2021-02-10;29971.000|2021-02-11;30134.000|2021-02-16;30697.000|2021-02-17;31059.000    ",
    M: "2021-01-18;2021-01-19;2021-01-20;2021-01-21;2021-01-22;2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11;2021-02-16=2021-01-18;28836.000|2021-01-19;29614.000|2021-01-20;29892.000|2021-01-21;29915.000|2021-01-22;29461.000|2021-01-25;30081.000|2021-01-26;29445.000|2021-01-27;29279.000|2021-01-28;28748.000|2021-01-29;28319.000|2021-02-01;28804.000|2021-02-02;29230.000|2021-02-03;29212.000|2021-02-04;29090.000|2021-02-05;29266.000|2021-02-08;29170.000|2021-02-09;29403.000|2021-02-10;29971.000|2021-02-11;30134.000|2021-02-16;30697.000|2021-02-17;31055.000    ",
    Y: "2020-02-18;2020-02-19;2020-02-20;2020-02-21;2020-02-24;2020-02-25;2020-02-26;2020-02-27;2020-02-28;2020-03-02;2020-03-03;2020-03-04;2020-03-05;2020-03-06;2020-03-09;2020-03-10;2020-03-11;2020-03-12;2020-03-13;2020-03-16;2020-03-17;2020-03-18;2020-03-19;2020-03-20;2020-03-23;2020-03-24;2020-03-25;2020-03-26;2020-03-27;2020-03-30;2020-03-31;2020-04-01;2020-04-02;2020-04-03;2020-04-06;2020-04-07;2020-04-08;2020-04-09;2020-04-14;2020-04-15;2020-04-16;2020-04-17;2020-04-20;2020-04-21;2020-04-22;2020-04-23;2020-04-24;2020-04-27;2020-04-28;2020-04-29;2020-05-04;2020-05-05;2020-05-06;2020-05-07;2020-05-08;2020-05-11;2020-05-12;2020-05-13;2020-05-14;2020-05-15;2020-05-18;2020-05-19;2020-05-20;2020-05-21;2020-05-22;2020-05-25;2020-05-26;2020-05-27;2020-05-28;2020-05-29;2020-06-01;2020-06-02;2020-06-03;2020-06-04;2020-06-05;2020-06-08;2020-06-09;2020-06-10;2020-06-11;2020-06-12;2020-06-15;2020-06-16;2020-06-17;2020-06-18;2020-06-19;2020-06-22;2020-06-23;2020-06-24;2020-06-26;2020-06-29;2020-06-30;2020-07-02;2020-07-03;2020-07-06;2020-07-07;2020-07-08;2020-07-09;2020-07-10;2020-07-13;2020-07-14;2020-07-15;2020-07-16;2020-07-17;2020-07-20;2020-07-21;2020-07-22;2020-07-23;2020-07-24;2020-07-27;2020-07-28;2020-07-29;2020-07-30;2020-07-31;2020-08-03;2020-08-04;2020-08-05;2020-08-06;2020-08-07;2020-08-10;2020-08-11;2020-08-12;2020-08-13;2020-08-14;2020-08-17;2020-08-18;2020-08-19;2020-08-20;2020-08-21;2020-08-24;2020-08-25;2020-08-26;2020-08-27;2020-08-28;2020-08-31;2020-09-01;2020-09-02;2020-09-03;2020-09-04;2020-09-07;2020-09-08;2020-09-09;2020-09-10;2020-09-11;2020-09-14;2020-09-15;2020-09-16;2020-09-17;2020-09-18;2020-09-21;2020-09-22;2020-09-23;2020-09-24;2020-09-25;2020-09-28;2020-09-29;2020-09-30;2020-10-05;2020-10-06;2020-10-07;2020-10-08;2020-10-09;2020-10-12;2020-10-13;2020-10-14;2020-10-15;2020-10-16;2020-10-19;2020-10-20;2020-10-21;2020-10-22;2020-10-23;2020-10-27;2020-10-28;2020-10-29;2020-10-30;2020-11-02;2020-11-03;2020-11-04;2020-11-05;2020-11-06;2020-11-09;2020-11-10;2020-11-11;2020-11-12;2020-11-13;2020-11-16;2020-11-17;2020-11-18;2020-11-19;2020-11-20;2020-11-23;2020-11-24;2020-11-25;2020-11-26;2020-11-27;2020-11-30;2020-12-01;2020-12-02;2020-12-03;2020-12-04;2020-12-07;2020-12-08;2020-12-09;2020-12-10;2020-12-11;2020-12-14;2020-12-15;2020-12-16;2020-12-17;2020-12-18;2020-12-21;2020-12-22;2020-12-23;2020-12-24;2020-12-28;2020-12-29;2020-12-30;2020-12-31;2021-01-04;2021-01-05;2021-01-06;2021-01-07;2021-01-08;2021-01-11;2021-01-12;2021-01-13;2021-01-14;2021-01-15;2021-01-18;2021-01-19;2021-01-20;2021-01-21;2021-01-22;2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11;2021-02-16=2020-02-18;27426.000|2020-02-19;27565.000|2020-02-20;27420.000|2020-02-21;27200.000|2020-02-24;26663.000|2020-02-25;26754.000|2020-02-26;26580.000|2020-02-27;26554.000|2020-02-28;26170.000|2020-03-02;26299.000|2020-03-03;26311.000|2020-03-04;26152.000|2020-03-05;26704.000|2020-03-06;26010.000|2020-03-09;24850.000|2020-03-10;25449.000|2020-03-11;25129.000|2020-03-12;24075.000|2020-03-13;23853.000|2020-03-16;22724.000|2020-03-17;23019.000|2020-03-18;22006.000|2020-03-19;21841.000|2020-03-20;23057.000|2020-03-23;21496.000|2020-03-24;22728.000|2020-03-25;23618.000|2020-03-26;23180.000|2020-03-27;23502.000|2020-03-30;23232.000|2020-03-31;23720.000|2020-04-01;22930.000|2020-04-02;23269.000|2020-04-03;23196.000|2020-04-06;23740.000|2020-04-07;24423.000|2020-04-08;23764.000|2020-04-09;24209.000|2020-04-14;24408.000|2020-04-15;24052.000|2020-04-16;23948.000|2020-04-17;24359.000|2020-04-20;24280.000|2020-04-21;23730.000|2020-04-22;23869.000|2020-04-23;23991.000|2020-04-24;23834.000|2020-04-27;24269.000|2020-04-28;24435.000|2020-04-29;24502.000|2020-05-04;23373.000|2020-05-05;23759.000|2020-05-06;24053.000|2020-05-07;23848.000|2020-05-08;24121.000|2020-05-11;24486.000|2020-05-12;24153.000|2020-05-13;24069.000|2020-05-14;23685.000|2020-05-15;23672.000|2020-05-18;23924.000|2020-05-19;24340.000|2020-05-20;24441.000|2020-05-21;24128.000|2020-05-22;22701.000|2020-05-25;22889.000|2020-05-26;23355.000|2020-05-27;23205.000|2020-05-28;23128.000|2020-05-29;22769.000|2020-06-01;23425.000|2020-06-02;23937.000|2020-06-03;24243.000|2020-06-04;24291.000|2020-06-05;24697.000|2020-06-08;24745.000|2020-06-09;24867.000|2020-06-10;25017.000|2020-06-11;24366.000|2020-06-12;24212.000|2020-06-15;23702.000|2020-06-16;24355.000|2020-06-17;24402.000|2020-06-18;24350.000|2020-06-19;24610.000|2020-06-22;24455.000|2020-06-23;24952.000|2020-06-24;24707.000|2020-06-26;24506.000|2020-06-29;24302.000|2020-06-30;24247.000|2020-07-02;25137.000|2020-07-03;25295.000|2020-07-06;26331.000|2020-07-07;25970.000|2020-07-08;26062.000|2020-07-09;26246.000|2020-07-10;25695.000|2020-07-13;25749.000|2020-07-14;25540.000|2020-07-15;25494.000|2020-07-16;24920.000|2020-07-17;25157.000|2020-07-20;25017.000|2020-07-21;25609.000|2020-07-22;25106.000|2020-07-23;25230.000|2020-07-24;24685.000|2020-07-27;24631.000|2020-07-28;24755.000|2020-07-29;24879.000|2020-07-30;24967.000|2020-07-31;24559.000|2020-08-03;24387.000|2020-08-04;24936.000|2020-08-05;25052.000|2020-08-06;24816.000|2020-08-07;24391.000|2020-08-10;24406.000|2020-08-11;24895.000|2020-08-12;25235.000|2020-08-13;25128.000|2020-08-14;25074.000|2020-08-17;25293.000|2020-08-18;25341.000|2020-08-19;25135.000|2020-08-20;24678.000|2020-08-21;25069.000|2020-08-24;25508.000|2020-08-25;25452.000|2020-08-26;25432.000|2020-08-27;25211.000|2020-08-28;25531.000|2020-08-31;25075.000|2020-09-01;25065.000|2020-09-02;25057.000|2020-09-03;24924.000|2020-09-04;24670.000|2020-09-07;24516.000|2020-09-08;24477.000|2020-09-09;24417.000|2020-09-10;24230.000|2020-09-11;24454.000|2020-09-14;24544.000|2020-09-15;24742.000|2020-09-16;24715.000|2020-09-17;24334.000|2020-09-18;24456.000|2020-09-21;23896.000|2020-09-22;23651.000|2020-09-23;23700.000|2020-09-24;23251.000|2020-09-25;23152.000|2020-09-28;23435.000|2020-09-29;23399.000|2020-09-30;23430.000|2020-10-05;23755.000|2020-10-06;23951.000|2020-10-07;24173.000|2020-10-08;24100.000|2020-10-09;24039.000|2020-10-12;24679.000|2020-10-13;24706.000|2020-10-14;24608.000|2020-10-15;24079.000|2020-10-16;24354.000|2020-10-19;24549.000|2020-10-20;24502.000|2020-10-21;24640.000|2020-10-22;24863.000|2020-10-23;24919.000|2020-10-27;24717.000|2020-10-28;24600.000|2020-10-29;24500.000|2020-10-30;24157.000|2020-11-02;24333.000|2020-11-03;25029.000|2020-11-04;24942.000|2020-11-05;25808.000|2020-11-06;25718.000|2020-11-09;26031.000|2020-11-10;26361.000|2020-11-11;26256.000|2020-11-12;26218.000|2020-11-13;26177.000|2020-11-16;26372.000|2020-11-17;26419.000|2020-11-18;26555.000|2020-11-19;26349.000|2020-11-20;26455.000|2020-11-23;26496.000|2020-11-24;26617.000|2020-11-25;26645.000|2020-11-26;26798.000|2020-11-27;26830.000|2020-11-30;26427.000|2020-12-01;26589.000|2020-12-02;26537.000|2020-12-03;26720.000|2020-12-04;26880.000|2020-12-07;26427.000|2020-12-08;26296.000|2020-12-09;26543.000|2020-12-10;26413.000|2020-12-11;26455.000|2020-12-14;26364.000|2020-12-15;26238.000|2020-12-16;26533.000|2020-12-17;26698.000|2020-12-18;26499.000|2020-12-21;26345.000|2020-12-22;26130.000|2020-12-23;26325.000|2020-12-24;26410.000|2020-12-28;26363.000|2020-12-29;26595.000|2020-12-30;26943.000|2020-12-31;27219.000|2021-01-04;27488.000|2021-01-05;27564.000|2021-01-06;27631.000|2021-01-07;27543.000|2021-01-08;27801.000|2021-01-11;27985.000|2021-01-12;28266.000|2021-01-13;28236.000|2021-01-14;28476.000|2021-01-15;28591.000|2021-01-18;28836.000|2021-01-19;29614.000|2021-01-20;29892.000|2021-01-21;29915.000|2021-01-22;29461.000|2021-01-25;30081.000|2021-01-26;29445.000|2021-01-27;29279.000|2021-01-28;28748.000|2021-01-29;28319.000|2021-02-01;28804.000|2021-02-02;29230.000|2021-02-03;29212.000|2021-02-04;29090.000|2021-02-05;29266.000|2021-02-08;29170.000|2021-02-09;29403.000|2021-02-10;29971.000|2021-02-11;30134.000|2021-02-16;30697.000|2021-02-17;31055.000",
    CALL: {
        "data": [
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.15",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.196",
                "percent_moneyness": "2",
                "last_trading_date": "23 Mar 21",
                "HIGH_1": "0.195",
                "type": "CALL",
                "effective_gearing": "14.0",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+18.18",
                "LOW_1": "0.040",
                "30D_LOW": "-",
                "ticker": "HGKW",
                "breakeven_price": "31,766.82",
                "underlying_pctchng": "+1.19",
                "delta_per_wrnt": "0.051",
                "warrant_price": 0.195,
                "TURNOVER_SCALED": "4,182",
                "OPEN_PRC": "0.042",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 30400MBeCW210330",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "11.35",
                "delta": "61.7",
                "TRADE_DATE": "17 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.8144,
                "BID_PCTCHNG": "+18.2",
                "BIDSIZE": "3,000,000",
                "category": "HSI",
                "underlying_price_cal": 31062.0,
                "exercise_price_adj": 5204.48,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 30400MBeCW210330",
                "YRHIGH": "-",
                "BEST_BSIZ1": "3000000",
                "HST_CLOSE": "0.165",
                "ACVOL_1_SCALED": "23,884",
                "BID": "0.195",
                "r_hst_close": 0.1712,
                "maturity": "30 Mar 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31061.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t212.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,062.00",
                "list_date": "08 Jan 21",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.196",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.030",
                "NETCHNG_1": "+0.0",
                "HST_VOL": "-",
                "implied_volatility": "24.4",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "06:45",
                "moneyness": "1",
                "ASKSIZE": "500,000",
                "premium": "2.3",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.094",
                "exercise_price_cal": 30400.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "4,182,183",
                "PCTCHNG": "+18.8",
                "YRLOW": "-",
                "BEST_ASIZ1": "500000",
                "ACVOL_1": "23,884,000",
                "days_to_maturity": "41",
                "ric": "HSML_t212.SI",
                "exercise_price": "30,400.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.09",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.188",
                "percent_moneyness": "0",
                "last_trading_date": "20 May 21",
                "HIGH_1": "0.255",
                "type": "CALL",
                "effective_gearing": "9.0",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+13.33",
                "LOW_1": "0.059",
                "30D_LOW": "-",
                "ticker": "Z7PW",
                "breakeven_price": "32,987.38",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.043",
                "warrant_price": 0.255,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.059",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 31200MBeCW210528",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "67.90",
                "delta": "51.6",
                "TRADE_DATE": "11 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+13.3",
                "BIDSIZE": "500,000",
                "underlying_price_cal": 31065.0,
                "exercise_price_adj": 5341.44,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 31200MBeCW210528",
                "YRHIGH": "-",
                "BEST_BSIZ1": "500000",
                "HST_CLOSE": "0.225",
                "ACVOL_1_SCALED": "0",
                "BID": "0.255",
                "r_hst_close": 0.1712,
                "maturity": "28 May 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31063.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t211.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,065.00",
                "list_date": "08 Jan 21",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.260",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.030",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "28.1",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "2",
                "ASKSIZE": "500,000",
                "premium": "6.2",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.000",
                "exercise_price_cal": 31200.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "500000",
                "ACVOL_1": "0",
                "days_to_maturity": "100",
                "ric": "HSML_t211.SI",
                "exercise_price": "31,200.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.01",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.510",
                "percent_moneyness": "17",
                "last_trading_date": "20 May 21",
                "HIGH_1": "0.670",
                "type": "CALL",
                "effective_gearing": "5.8",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+7.20",
                "LOW_1": "0.325",
                "30D_LOW": "-",
                "ticker": "OKCW",
                "breakeven_price": "31,296.26",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.074",
                "warrant_price": 0.67,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.325",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 26600MBeCW210528",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "39.66",
                "delta": "88.4",
                "TRADE_DATE": "27 Jan 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.8144,
                "BID_PCTCHNG": "+7.2",
                "BIDSIZE": "10,000",
                "underlying_price_cal": 31065.0,
                "exercise_price_adj": 4553.92,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 26600MBeCW210528",
                "YRHIGH": "-",
                "BEST_BSIZ1": "10000",
                "HST_CLOSE": "0.625",
                "ACVOL_1_SCALED": "0",
                "BID": "0.670",
                "r_hst_close": 0.1712,
                "maturity": "28 May 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31063.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t209.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,065.00",
                "list_date": "08 Jan 21",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.680",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.045",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "26.0",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "10,000",
                "premium": "0.7",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.637",
                "exercise_price_cal": 26600.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "10000",
                "ACVOL_1": "0",
                "days_to_maturity": "100",
                "ric": "HSML_t209.SI",
                "exercise_price": "26,600.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.04",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.340",
                "percent_moneyness": "9",
                "last_trading_date": "22 Apr 21",
                "HIGH_1": "0.445",
                "type": "CALL",
                "effective_gearing": "8.0",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+11.25",
                "LOW_1": "0.068",
                "30D_LOW": "-",
                "ticker": "SGAW",
                "breakeven_price": "31,519.16",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.066",
                "warrant_price": 0.44,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.112",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 28400MBeCW210429",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "44.06",
                "delta": "79.5",
                "TRADE_DATE": "20 Jan 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.8144,
                "BID_PCTCHNG": "+11.2",
                "BIDSIZE": "300,000",
                "underlying_price_cal": 31065.0,
                "exercise_price_adj": 4862.08,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 28400MBeCW210429",
                "YRHIGH": "-",
                "BEST_BSIZ1": "300000",
                "HST_CLOSE": "0.400",
                "ACVOL_1_SCALED": "0",
                "BID": "0.445",
                "r_hst_close": 0.1712,
                "maturity": "29 Apr 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31063.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t201.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,065.00",
                "list_date": "16 Dec 20",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.450",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.045",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "26.2",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "300,000",
                "premium": "1.5",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.380",
                "exercise_price_cal": 28400.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "300000",
                "ACVOL_1": "0",
                "days_to_maturity": "71",
                "ric": "HSML_t201.SI",
                "exercise_price": "28,400.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.08",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.220",
                "percent_moneyness": "4",
                "last_trading_date": "22 Apr 21",
                "HIGH_1": "0.280",
                "type": "CALL",
                "effective_gearing": "10.2",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+14.29",
                "LOW_1": "0.051",
                "30D_LOW": "-",
                "ticker": "XLDW",
                "breakeven_price": "31,962.62",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.054",
                "warrant_price": 0.28,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.065",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 30000MBeCW210429",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "54.48",
                "delta": "64.3",
                "TRADE_DATE": "10 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+14.3",
                "BIDSIZE": "500,000",
                "underlying_price_cal": 31065.0,
                "exercise_price_adj": 5136.0,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 30000MBeCW210429",
                "YRHIGH": "-",
                "BEST_BSIZ1": "500000",
                "HST_CLOSE": "0.245",
                "ACVOL_1_SCALED": "0",
                "BID": "0.280",
                "r_hst_close": 0.1712,
                "maturity": "29 Apr 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31063.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t203.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,065.00",
                "list_date": "16 Dec 20",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.285",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.035",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "24.9",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "500,000",
                "premium": "2.9",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.152",
                "exercise_price_cal": 30000.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "500000",
                "ACVOL_1": "0",
                "days_to_maturity": "71",
                "ric": "HSML_t203.SI",
                "exercise_price": "30,000.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.11",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.220",
                "percent_moneyness": "1",
                "last_trading_date": "22 Apr 21",
                "HIGH_1": "0.220",
                "type": "CALL",
                "effective_gearing": "11.1",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+14.58",
                "LOW_1": "0.141",
                "30D_LOW": "-",
                "ticker": "X5OW",
                "breakeven_price": "32,342.06",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.046",
                "warrant_price": 0.22,
                "TURNOVER_SCALED": "616",
                "OPEN_PRC": "0.142",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 30800MBeCW210429",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "63.63",
                "delta": "55.1",
                "TRADE_DATE": "17 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+14.6",
                "BIDSIZE": "1,000,000",
                "underlying_price_cal": 31064.0,
                "exercise_price_adj": 5272.96,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 30800MBeCW210429",
                "YRHIGH": "-",
                "BEST_BSIZ1": "1000000",
                "HST_CLOSE": "0.192",
                "ACVOL_1_SCALED": "3,120",
                "BID": "0.220",
                "r_hst_close": 0.1712,
                "maturity": "29 Apr 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31062.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t216.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,064.00",
                "list_date": "11 Feb 21",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.225",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.028",
                "NETCHNG_1": "+0.0",
                "HST_VOL": "-",
                "implied_volatility": "26.0",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "06:33",
                "moneyness": "1",
                "ASKSIZE": "1,000,000",
                "premium": "4.1",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.038",
                "exercise_price_cal": 30800.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "615,910",
                "PCTCHNG": "+13.4",
                "YRLOW": "-",
                "BEST_ASIZ1": "1000000",
                "ACVOL_1": "3,120,000",
                "days_to_maturity": "71",
                "ric": "HSML_t216.SI",
                "exercise_price": "30,800.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.06",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.220",
                "percent_moneyness": "6",
                "last_trading_date": "22 Apr 21",
                "HIGH_1": "0.370",
                "type": "CALL",
                "effective_gearing": "8.5",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+10.45",
                "LOW_1": "0.057",
                "30D_LOW": "-",
                "ticker": "DZBW",
                "breakeven_price": "31,793.46",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.059",
                "warrant_price": 0.37,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.083",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 29200MBeCW210429",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "49.31",
                "delta": "71.1",
                "TRADE_DATE": "04 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+10.4",
                "BIDSIZE": "300,000",
                "underlying_price_cal": 31064.0,
                "exercise_price_adj": 4999.04,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 29200MBeCW210429",
                "YRHIGH": "-",
                "BEST_BSIZ1": "300000",
                "HST_CLOSE": "0.335",
                "ACVOL_1_SCALED": "0",
                "BID": "0.370",
                "r_hst_close": 0.1712,
                "maturity": "29 Apr 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31062.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t202.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,064.00",
                "list_date": "16 Dec 20",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.375",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.035",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "28.1",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "300,000",
                "premium": "2.3",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.266",
                "exercise_price_cal": 29200.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "300000",
                "ACVOL_1": "0",
                "days_to_maturity": "71",
                "ric": "HSML_t202.SI",
                "exercise_price": "29,200.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.05",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.235",
                "percent_moneyness": "8",
                "last_trading_date": "23 Mar 21",
                "HIGH_1": "0.360",
                "type": "CALL",
                "effective_gearing": "10.2",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+14.29",
                "LOW_1": "0.054",
                "30D_LOW": "-",
                "ticker": "QHEW",
                "breakeven_price": "31,323.37",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.069",
                "warrant_price": 0.36,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.073",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 28800MBeCW210330",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "42.24",
                "delta": "83.0",
                "TRADE_DATE": "27 Jan 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+14.3",
                "BIDSIZE": "300,000",
                "underlying_price_cal": 31064.0,
                "exercise_price_adj": 4930.56,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 28800MBeCW210330",
                "YRHIGH": "-",
                "BEST_BSIZ1": "300000",
                "HST_CLOSE": "0.315",
                "ACVOL_1_SCALED": "0",
                "BID": "0.360",
                "r_hst_close": 0.1712,
                "maturity": "30 Mar 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31062.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t198.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,064.00",
                "list_date": "15 Dec 20",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.365",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.045",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "24.5",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "300,000",
                "premium": "0.8",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.323",
                "exercise_price_cal": 28800.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "300000",
                "ACVOL_1": "0",
                "days_to_maturity": "41",
                "ric": "HSML_t198.SI",
                "exercise_price": "28,800.00"
            },
            {
                "underlying_ric": "HSIc1",
                "b_trbc_business": null,
                "theta": "-0.09",
                "LOLIMIT": "0",
                "TRDPRC_1": "0.180",
                "percent_moneyness": "5",
                "last_trading_date": "23 Mar 21",
                "HIGH_1": "0.275",
                "type": "CALL",
                "effective_gearing": "11.8",
                "conv_ratio": "1,200.0",
                "wrnt_per_share": "0.001",
                "BID_PCTCHNG_2DP": "+17.02",
                "LOW_1": "0.170",
                "30D_LOW": "-",
                "ticker": "5N8W",
                "breakeven_price": "31,527.57",
                "underlying_pctchng": "+1.20",
                "delta_per_wrnt": "0.061",
                "warrant_price": 0.275,
                "TURNOVER_SCALED": "0",
                "OPEN_PRC": "0.172",
                "NO_BIDMKR2": "-",
                "dsply_nmll": "HSI 29600MBeCW210330",
                "issuer_name": "Macquarie Bank Ltd",
                "sensitivity": "47.97",
                "delta": "73.1",
                "TRADE_DATE": "11 Feb 21",
                "NO_BIDMKR2_SCALED": "-",
                "underlying_price_adj": 5317.472,
                "BID_PCTCHNG": "+17.0",
                "BIDSIZE": "500,000",
                "underlying_price_cal": 31064.0,
                "exercise_price_adj": 5067.52,
                "update_time": "17 Feb 21 14:48",
                "dsply_name": "HSI 29600MBeCW210330",
                "YRHIGH": "-",
                "BEST_BSIZ1": "500000",
                "HST_CLOSE": "0.235",
                "ACVOL_1_SCALED": "0",
                "BID": "0.275",
                "r_hst_close": 0.1712,
                "maturity": "30 Mar 21",
                "div_yield": 1.203788462,
                "underlying_bid": 31062.0,
                "fmt": 1,
                "30D_HIGH": "-",
                "SYMBOL": "HSML_t215.SI",
                "HST_VOL_SCALED": "-",
                "underlying_price": "31,064.00",
                "list_date": "11 Feb 21",
                "underlying_curr": "HKD",
                "exchange_code": "SES",
                "ASK": "0.280",
                "currency": "SGD",
                "conv_ratio_cal": 1200.00048,
                "UPLIMIT": "0",
                "BID_NETCHNG": "+0.040",
                "NETCHNG_1": "0.0",
                "HST_VOL": "-",
                "implied_volatility": "24.8",
                "VOL_PCTCHNG": "-",
                "TRDTIM_1": "  :",
                "moneyness": "1",
                "ASKSIZE": "500,000",
                "premium": "1.5",
                "SERVICE": "ELEKTRON_DD",
                "underlying_ticker": "HSI",
                "intrinsic_value": "0.209",
                "exercise_price_cal": 29600.0,
                "issuer_code": "MBL",
                "REC_STATUS": "0",
                "underlying_name": "HSI",
                "TURNOVER": "0",
                "PCTCHNG": "0.0",
                "YRLOW": "-",
                "BEST_ASIZ1": "500000",
                "ACVOL_1": "0",
                "days_to_maturity": "41",
                "ric": "HSML_t215.SI",
                "exercise_price": "29,600.00"
            }
        ]        
    },
    PUT: {
      "data": [
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.55",
              "TRDPRC_1": "0.043",
              "percent_moneyness": "8",
              "last_trading_date": "23 Mar 21",
              "HIGH_1": "0.079",
              "type": "PUT",
              "effective_gearing": "19.0",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-6.67",
              "LOW_1": "0.030",
              "30D_LOW": "-",
              "ticker": "9PCW",
              "breakeven_price": "27,905.26",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.015",
              "warrant_price": 0.042000000,
              "TURNOVER_SCALED": "12",
              "OPEN_PRC": "0.077",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 28200MBePW210330",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "38.35",
              "delta": "-18.3",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-6.7",
              "BIDSIZE": "3,000,000",
              "category": "HSI",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4822.200000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 28200MBePW210330",
              "YRHIGH": "-",
              "HST_CLOSE": "0.045",
              "ACVOL_1_SCALED": "245",
              "BID": "0.042",
              "r_hst_close": 0.1710000000,
              "maturity": "30 Mar 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "11 Feb 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.043",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.003",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "28.4",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "3,000,000",
              "premium": "8.7",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 28200.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "12,275",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "245,000",
              "days_to_maturity": "39",
              "ric": "HSML_t213.SI",
              "exercise_price": "28,200.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.22",
              "TRDPRC_1": "0.069",
              "percent_moneyness": "16",
              "last_trading_date": "20 May 21",
              "HIGH_1": "0.097",
              "type": "PUT",
              "effective_gearing": "10.5",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-4.17",
              "LOW_1": "0.057",
              "30D_LOW": "-",
              "ticker": "EGAW",
              "breakeven_price": "25,915.79",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.014",
              "warrant_price": 0.069000000,
              "TURNOVER_SCALED": "490",
              "OPEN_PRC": "0.097",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 26400MBePW210528",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "42.07",
              "delta": "-16.7",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-4.2",
              "BIDSIZE": "500,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4514.400000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 26400MBePW210528",
              "YRHIGH": "-",
              "HST_CLOSE": "0.072",
              "ACVOL_1_SCALED": "6,606",
              "BID": "0.069",
              "r_hst_close": 0.1710000000,
              "maturity": "28 May 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "11 Feb 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.070",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.003",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "31.9",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "500,000",
              "premium": "15.3",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 26400.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "490,017",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "6,606,000",
              "days_to_maturity": "98",
              "ric": "HSML_t214.SI",
              "exercise_price": "26,400.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.16",
              "TRDPRC_1": "0.121",
              "percent_moneyness": "9",
              "last_trading_date": "20 May 21",
              "HIGH_1": "0.300",
              "type": "PUT",
              "effective_gearing": "9.6",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-3.23",
              "LOW_1": "0.093",
              "30D_LOW": "-",
              "ticker": "1HZW",
              "breakeven_price": "27,157.89",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.022",
              "warrant_price": 0.120000000,
              "TURNOVER_SCALED": "21",
              "OPEN_PRC": "0.300",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 28000MBePW210528",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "26.59",
              "delta": "-26.4",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-3.2",
              "BIDSIZE": "304,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4788.000000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 28000MBePW210528",
              "YRHIGH": "-",
              "HST_CLOSE": "0.124",
              "ACVOL_1_SCALED": "170",
              "BID": "0.120",
              "r_hst_close": 0.1710000000,
              "maturity": "28 May 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "08 Jan 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.122",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.004",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "30.6",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "300,000",
              "premium": "11.2",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 28000.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "21,227",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "169,700",
              "days_to_maturity": "98",
              "ric": "HSML_t207.SI",
              "exercise_price": "28,000.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.28",
              "TRDPRC_1": "0.085",
              "percent_moneyness": "23",
              "last_trading_date": "20 May 21",
              "HIGH_1": "0.128",
              "type": "PUT",
              "effective_gearing": "10.4",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-4.17",
              "LOW_1": "0.039",
              "30D_LOW": "-",
              "ticker": "TPCW",
              "breakeven_price": "24,477.19",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.009",
              "warrant_price": 0.046000000,
              "TURNOVER_SCALED": "0",
              "OPEN_PRC": "0.121",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 24800MBePW210528",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "63.86",
              "delta": "-11.0",
              "TRADE_DATE": "08 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-4.2",
              "BIDSIZE": "500,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4240.800000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 24800MBePW210528",
              "YRHIGH": "-",
              "HST_CLOSE": "0.048",
              "ACVOL_1_SCALED": "0",
              "BID": "0.046",
              "r_hst_close": 0.1710000000,
              "maturity": "28 May 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "08 Jan 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.048",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.002",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "35.5",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "200,000",
              "premium": "20.0",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 24800.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "0",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "0",
              "days_to_maturity": "98",
              "ric": "HSML_t210.SI",
              "exercise_price": "24,800.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.44",
              "TRDPRC_1": "0.064",
              "percent_moneyness": "20",
              "last_trading_date": "22 Apr 21",
              "HIGH_1": "0.191",
              "type": "PUT",
              "effective_gearing": "13.4",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-3.13",
              "LOW_1": "0.024",
              "30D_LOW": "-",
              "ticker": "FMPW",
              "breakeven_price": "25,182.46",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "N/A",
              "warrant_price": 0.031000000,
              "TURNOVER_SCALED": "0",
              "OPEN_PRC": "0.175",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 25400MBePW210429",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "73.57",
              "delta": "-9.5",
              "TRADE_DATE": "08 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-3.1",
              "BIDSIZE": "500,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4343.400000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 25400MBePW210429",
              "YRHIGH": "-",
              "HST_CLOSE": "0.032",
              "ACVOL_1_SCALED": "0",
              "BID": "0.031",
              "r_hst_close": 0.1710000000,
              "maturity": "29 Apr 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "16 Dec 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.032",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.001",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "34.4",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "500,000",
              "premium": "17.7",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 25400.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "0",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "0",
              "days_to_maturity": "69",
              "ric": "HSML_t204.SI",
              "exercise_price": "25,400.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.22",
              "TRDPRC_1": "0.105",
              "percent_moneyness": "7",
              "last_trading_date": "22 Apr 21",
              "HIGH_1": "0.315",
              "type": "PUT",
              "effective_gearing": "11.8",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-4.59",
              "LOW_1": "0.076",
              "30D_LOW": "-",
              "ticker": "CVCW",
              "breakeven_price": "27,870.18",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.023",
              "warrant_price": 0.104000000,
              "TURNOVER_SCALED": "2,516",
              "OPEN_PRC": "0.315",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 28600MBePW210429",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "24.93",
              "delta": "-28.1",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-4.6",
              "BIDSIZE": "1,135,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4890.600000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 28600MBePW210429",
              "YRHIGH": "-",
              "HST_CLOSE": "0.109",
              "ACVOL_1_SCALED": "22,205",
              "BID": "0.104",
              "r_hst_close": 0.1710000000,
              "maturity": "29 Apr 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "08 Jan 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.106",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.005",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "29.4",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "1,015,000",
              "premium": "8.9",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 28600.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "2,516,387",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "22,205,400",
              "days_to_maturity": "69",
              "ric": "HSML_t206.SI",
              "exercise_price": "28,600.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.32",
              "TRDPRC_1": "0.060",
              "percent_moneyness": "13",
              "last_trading_date": "22 Apr 21",
              "HIGH_1": "0.305",
              "type": "PUT",
              "effective_gearing": "12.5",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-4.76",
              "LOW_1": "0.049",
              "30D_LOW": "-",
              "ticker": "8XWW",
              "breakeven_price": "26,578.95",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.014",
              "warrant_price": 0.060000000,
              "TURNOVER_SCALED": "108",
              "OPEN_PRC": "0.280",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 27000MBePW210429",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "40.92",
              "delta": "-17.1",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-4.8",
              "BIDSIZE": "400,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4617.000000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 27000MBePW210429",
              "YRHIGH": "-",
              "HST_CLOSE": "0.063",
              "ACVOL_1_SCALED": "1,556",
              "BID": "0.060",
              "r_hst_close": 0.1710000000,
              "maturity": "29 Apr 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "16 Dec 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.062",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.003",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "32.3",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "1,000,000",
              "premium": "13.1",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 27000.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "108,260",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "1,556,000",
              "days_to_maturity": "69",
              "ric": "HSML_t199.SI",
              "exercise_price": "27,000.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.38",
              "TRDPRC_1": "0.044",
              "percent_moneyness": "17",
              "last_trading_date": "22 Apr 21",
              "HIGH_1": "0.240",
              "type": "PUT",
              "effective_gearing": "13.3",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-6.82",
              "LOW_1": "0.026",
              "30D_LOW": "-",
              "ticker": "TNSW",
              "breakeven_price": "25,912.28",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.010",
              "warrant_price": 0.041000000,
              "TURNOVER_SCALED": "0",
              "OPEN_PRC": "0.220",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 26200MBePW210429",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "56.05",
              "delta": "-12.5",
              "TRADE_DATE": "18 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-6.8",
              "BIDSIZE": "500,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4480.200000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 26200MBePW210429",
              "YRHIGH": "-",
              "HST_CLOSE": "0.044",
              "ACVOL_1_SCALED": "0",
              "BID": "0.041",
              "r_hst_close": 0.1710000000,
              "maturity": "29 Apr 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "16 Dec 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.042",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.003",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "32.7",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "500,000",
              "premium": "15.3",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 26200.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "0",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "0",
              "days_to_maturity": "69",
              "ric": "HSML_t205.SI",
              "exercise_price": "26,200.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.93",
              "TRDPRC_1": "0.021",
              "percent_moneyness": "19",
              "last_trading_date": "23 Mar 21",
              "HIGH_1": "0.190",
              "type": "PUT",
              "effective_gearing": "18.9",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-11.76",
              "LOW_1": "0.011",
              "30D_LOW": "-",
              "ticker": "KWBW",
              "breakeven_price": "25,694.74",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "N/A",
              "warrant_price": 0.015000000,
              "TURNOVER_SCALED": "1",
              "OPEN_PRC": "0.171",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 25800MBePW210330",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "107.72",
              "delta": "-6.5",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-11.8",
              "BIDSIZE": "550,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4411.800000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 25800MBePW210330",
              "YRHIGH": "-",
              "HST_CLOSE": "0.017",
              "ACVOL_1_SCALED": "45",
              "BID": "0.015",
              "r_hst_close": 0.1710000000,
              "maturity": "30 Mar 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "15 Dec 20",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.016",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.002",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "35.4",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "500,000",
              "premium": "16.0",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 25800.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "855",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "45,000",
              "days_to_maturity": "39",
              "ric": "HSML_t197.SI",
              "exercise_price": "25,800.00"
          },
          {
              "underlying_ric": "HSIc1",
              "b_trbc_business": null,
              "theta": "-0.64",
              "TRDPRC_1": "0.036",
              "percent_moneyness": "12",
              "last_trading_date": "23 Mar 21",
              "HIGH_1": "0.191",
              "type": "PUT",
              "effective_gearing": "17.4",
              "conv_ratio": "1,200.0",
              "wrnt_per_share": "0.001",
              "BID_PCTCHNG_2DP": "-7.69",
              "LOW_1": "0.027",
              "30D_LOW": "-",
              "ticker": "EEKW",
              "breakeven_price": "27,147.37",
              "underlying_pctchng": "+0.70",
              "delta_per_wrnt": "-0.012",
              "warrant_price": 0.036000000,
              "TURNOVER_SCALED": "148",
              "OPEN_PRC": "0.191",
              "NO_BIDMKR2": "-",
              "dsply_nmll": "HSI 27400MBePW210330",
              "issuer_name": "Macquarie Bank Ltd",
              "sensitivity": "48.87",
              "delta": "-14.4",
              "TRADE_DATE": "19 Feb 21",
              "NO_BIDMKR2_SCALED": "-",
              "underlying_price_adj": 5229.180000000,
              "BID_PCTCHNG": "-7.7",
              "BIDSIZE": "510,000",
              "underlying_price_cal": 30580.000000000,
              "exercise_price_adj": 4685.400000000,
              "update_time": "19 Feb 21 16:27",
              "dsply_name": "HSI 27400MBePW210330",
              "YRHIGH": "-",
              "HST_CLOSE": "0.039",
              "ACVOL_1_SCALED": "3,547",
              "BID": "0.036",
              "r_hst_close": 0.1710000000,
              "maturity": "30 Mar 21",
              "div_yield": 1.206250000,
              "underlying_bid": 30580.000000000,
              "fmt": 1,
              "30D_HIGH": "-",
              "HST_VOL_SCALED": "-",
              "underlying_price": "30,580.00",
              "list_date": "08 Jan 21",
              "underlying_curr": "HKD",
              "exchange_code": "SES",
              "ASK": "0.037",
              "currency": "SGD",
              "conv_ratio_cal": 1200.000480000,
              "BID_NETCHNG": "-0.003",
              "NETCHNG_1": "-",
              "HST_VOL": "-",
              "implied_volatility": "32.8",
              "VOL_PCTCHNG": "-",
              "moneyness": "2",
              "ASKSIZE": "550,000",
              "premium": "11.2",
              "underlying_ticker": "HSI",
              "intrinsic_value": "0.000",
              "exercise_price_cal": 27400.000000000,
              "issuer_code": "MBL",
              "underlying_name": "HSI",
              "TURNOVER": "147,512",
              "PCTCHNG": "-",
              "YRLOW": "-",
              "ACVOL_1": "3,547,000",
              "days_to_maturity": "39",
              "ric": "HSML_t208.SI",
              "exercise_price": "27,400.00"
          }
      ]
  }

}

// 20210216151119
// https://www.warrants.com.sg/SymbolsJSON?type=s&qid=1613459466766
const symbols = {
    "symbols": [
      {
        "symbol": "HSI",
        "ric": "HSIc1",
        "dsply_name": "HANG SENG FEB1",
        "TRDPRC_1": 30723.000000000,
        "name": "HSI",
        "PCTCHNG": 1.950000000
      },
      {
        "symbol": "N225",
        "ric": "SSIcv1",
        "dsply_name": "NIKKEI 225 MAR21",
        "TRDPRC_1": 30575.000000000,
        "name": "N225",
        "PCTCHNG": 0.020000000
      },
      {
        "symbol": "S&P500",
        "ric": "ESc1",
        "dsply_name": "EMINI S&P MAR1",
        "TRDPRC_1": 3953.250000000,
        "name": "S&P500",
        "PCTCHNG": 0.570000000
      },
      {
        "symbol": "STI",
        "ric": ".STI",
        "dsply_name": "STRAITS TIMES",
        "TRDPRC_1": 2942.760000000,
        "name": "STI",
        "PCTCHNG": 0.380000000
      },
      {
        "symbol": "A17U",
        "ric": "AEMN.SI",
        "dsply_name": "ASCEN REIT",
        "TRDPRC_1": 3.090000000,
        "name": "ASCEN REIT",
        "PCTCHNG": 0
      },
      {
        "symbol": "AIY",
        "ric": "IFAS.SI",
        "dsply_name": "IFAST CORPORATIO",
        "TRDPRC_1": 6.170000000,
        "name": "IFAST CORPORATIO",
        "PCTCHNG": -2.370000000
      },
      {
        "symbol": "AWX",
        "ric": "AEM.SI",
        "dsply_name": "AEM HOLDINGS LTD",
        "TRDPRC_1": 4.580000000,
        "name": "AEM HOLDINGS LTD",
        "PCTCHNG": -0.870000000
      },
      {
        "symbol": "BABA-SW",
        "ric": "9988.HK",
        "dsply_name": "BABA-SW",
        "TRDPRC_1": 264.800000000,
        "name": "BABA-SW",
        "PCTCHNG": 1.460000000
      },
      {
        "symbol": "BN4",
        "ric": "KPLM.SI",
        "dsply_name": "KEPPEL CORPORATI",
        "TRDPRC_1": 5.190000000,
        "name": "KEPCORP",
        "PCTCHNG": 0.780000000
      },
      {
        "symbol": "BS6",
        "ric": "YAZG.SI",
        "dsply_name": "YANGZIJIANG SHIP",
        "TRDPRC_1": 1.070000000,
        "name": "YANGZIJIANG",
        "PCTCHNG": 0
      },
      {
        "symbol": "BVA",
        "ric": "TOPG.SI",
        "dsply_name": "TOP GLOVE CORPOR",
        "TRDPRC_1": 2.020000000,
        "name": "TOP GLOVE CORPOR",
        "PCTCHNG": -0.980000000
      },
      {
        "symbol": "BYD COMPANY",
        "ric": "1211.HK",
        "dsply_name": "BYD COMPANY",
        "TRDPRC_1": 269.800000000,
        "name": "BYD COMPANY",
        "PCTCHNG": 1.810000000
      },
      {
        "symbol": "C09",
        "ric": "CTDM.SI",
        "dsply_name": "CITY DEVELOPMENT",
        "TRDPRC_1": 7.170000000,
        "name": "CITY DEVELOPMENT",
        "PCTCHNG": -0.830000000
      },
      {
        "symbol": "C31",
        "ric": "CATL.SI",
        "dsply_name": "CAPITALAND LIMIT",
        "TRDPRC_1": 3.140000000,
        "name": "CAPLAND",
        "PCTCHNG": -0.320000000
      },
      {
        "symbol": "C52",
        "ric": "CMDG.SI",
        "dsply_name": "COMFORTDELGRO LD",
        "TRDPRC_1": 1.580000000,
        "name": "COMFORTDELGRO LD",
        "PCTCHNG": 0
      },
      {
        "symbol": "C6L",
        "ric": "SIAL.SI",
        "dsply_name": "SINGAPORE AIRLIN",
        "TRDPRC_1": 4.400000000,
        "name": "SINGAPORE AIRLIN",
        "PCTCHNG": 1.380000000
      },
      {
        "symbol": "D05",
        "ric": "DBSM.SI",
        "dsply_name": "DBS GROUP HOLDIN",
        "TRDPRC_1": 26.010000000,
        "name": "DBS",
        "PCTCHNG": 0.500000000
      },
      {
        "symbol": "F34",
        "ric": "WLIL.SI",
        "dsply_name": "WILMAR INTERNATI",
        "TRDPRC_1": 5.530000000,
        "name": "WILMAR INTERNATI",
        "PCTCHNG": 1.650000000
      },
      {
        "symbol": "G13",
        "ric": "GENS.SI",
        "dsply_name": "GENTING SINGAPOR",
        "TRDPRC_1": 0.855000000,
        "name": "GENTINGSIN",
        "PCTCHNG": -0.580000000
      },
      {
        "symbol": "GEELY AUTO",
        "ric": "0175.HK",
        "dsply_name": "GEELY AUTO",
        "TRDPRC_1": 30.150000000,
        "name": "GEELY AUTO",
        "PCTCHNG": 1.010000000
      },
      {
        "symbol": "JD-SW",
        "ric": "9618.HK",
        "dsply_name": "JD-SW",
        "TRDPRC_1": 392.000000000,
        "name": "JD-SW",
        "PCTCHNG": 1.340000000
      },
      {
        "symbol": "MEITUAN-W",
        "ric": "3690.HK",
        "dsply_name": "MEITUAN-W",
        "TRDPRC_1": 439.400000000,
        "name": "MEITUAN-W",
        "PCTCHNG": -1.260000000
      },
      {
        "symbol": "N2IU",
        "ric": "MACT.SI",
        "dsply_name": "MAPLETREE COMMER",
        "TRDPRC_1": 2.050000000,
        "name": "MAPLETREE COMMER",
        "PCTCHNG": 0
      },
      {
        "symbol": "O39",
        "ric": "OCBC.SI",
        "dsply_name": "OVERSEA-CHINESE",
        "TRDPRC_1": 10.640000000,
        "name": "OCBC",
        "PCTCHNG": 0.380000000
      },
      {
        "symbol": "S68",
        "ric": "SGXL.SI",
        "dsply_name": "SINGAPORE EXCHAN",
        "TRDPRC_1": 9.990000000,
        "name": "SGX",
        "PCTCHNG": -0.100000000
      },
      {
        "symbol": "SUNNY OPTICAL",
        "ric": "2382.HK",
        "dsply_name": "SUNNY OPTICAL",
        "TRDPRC_1": 237.800000000,
        "name": "SUNNY OPTICAL",
        "PCTCHNG": 7.120000000
      },
      {
        "symbol": "TENCENT",
        "ric": "0700.HK",
        "dsply_name": "TENCENT",
        "TRDPRC_1": 748.500000000,
        "name": "TENCENT",
        "PCTCHNG": -1.120000000
      },
      {
        "symbol": "U11",
        "ric": "UOBH.SI",
        "dsply_name": "UNITED OVERSEAS",
        "TRDPRC_1": 24.030000000,
        "name": "UOB",
        "PCTCHNG": 0.290000000
      },
      {
        "symbol": "U14",
        "ric": "UTOS.SI",
        "dsply_name": "UOL GROUP LIMITE",
        "TRDPRC_1": 7.390000000,
        "name": "UOL GROUP LIMITE",
        "PCTCHNG": -0.540000000
      },
      {
        "symbol": "XIAOMI-W",
        "ric": "1810.HK",
        "dsply_name": "XIAOMI-W",
        "TRDPRC_1": 29.250000000,
        "name": "XIAOMI-W",
        "PCTCHNG": 4.280000000
      },
      {
        "symbol": "Z74",
        "ric": "STEL.SI",
        "dsply_name": "SINGTEL",
        "TRDPRC_1": 2.430000000,
        "name": "SINGTEL",
        "PCTCHNG": 1.250000000
      }
    ]
}

const selectorData = {
    "symbols": symbols,
    "9988.HK": ALIBABA,
    "HSIc1": HSI
}


export default selectorData;